import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=b45e97ca&scoped=true"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=b45e97ca&prod&lang=less&scoped=true"
import style1 from "./loginPage.vue?vue&type=style&index=1&id=b45e97ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45e97ca",
  null
  
)

export default component.exports